<script setup lang="ts">
import WithdrawRequestsContainer from './containers/WithdrawRequestsContainer.vue'
</script>

<template>
  <WithdrawRequestsContainer />
</template>
